/*
  Featured Products
*/
const initFeaturedProducts = () => {
  document.querySelectorAll('.featured-products:not(.init)').forEach(section => {
    section.classList.add('init')

    section.querySelectorAll('.splide').forEach(element => {
      const mySplide = new Splide(element, {
        arrows: element.dataset.arrows === 'true',
        pagination: element.dataset.pagination === 'true',
        easing: element.dataset.easing,
        speed: Number(element.dataset.speed),
        perMove: Number(element.dataset.perMove),
        autoplay: element.dataset.autoplay === 'true',
        interval: Number(element.dataset.interval),
        per_move: Number(element.dataset.perMove),
        rewind: element.dataset.rewind === 'true',
        mediaQuery: 'min',
        breakpoints: {
          0: { perPage: Number(element.dataset.breakpointXs), padding: element.dataset.breakpointXsPartial === 'true' ? { right: '16%' } : 0 },
          576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
          768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
          992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
          1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
          1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
        },
        direction: document.documentElement.getAttribute('dir')
      })

      const fixArrowsPos = () => {
        let top = section.querySelector('.product-item-img')?.clientHeight / 2

        if (section.querySelector('.product-item .card')) {
          top = section.querySelector('.card')?.clientHeight / 2
        }

        section.querySelectorAll('.splide__arrow').forEach(arrow => {
          arrow.style.top = `${top}px`
        })
      }

      const fixPagination = () => {
        if (window.matchMedia('(max-width: 575px').matches) {
          const pagination = section.querySelector('.splide__pagination')

          if (!pagination) return

          section.querySelector('.splide__pagination--mobile')?.remove()

          const total = pagination.querySelectorAll('button').length

          let text = element.dataset.textSlideOf.replace('[x]', mySplide.index + 1)
          text = text.replace('[total]', total)

          pagination.insertAdjacentHTML('beforebegin', `
                        <div class="splide__pagination--mobile text-muted small">
                            ${text}
                        </div>
                    `)
        }
      }

      mySplide.on('ready resize', () => {
        fixArrowsPos()
        fixPagination()
      })

      mySplide.on('move', () => {
        fixPagination()
      })

      mySplide.mount()

      section.querySelectorAll('button[data-bs-toggle="tab"]').forEach(elem => {
        elem.addEventListener('shown.bs.tab', event => {
          mySplide.refresh()
        })
      })
    })
  })
}
initFeaturedProducts()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.featured-products')) {
    initFeaturedProducts()
  }
})

/*
  Recommended Products
  https://shopify.dev/themes/product-merchandising/recommendations
*/
const initRecommendedProducts = async () => {
  const section = document.querySelector('.recommended-products')

  if (!section) return

  const { sectionId, baseUrl, productId, limit, intent } = section.dataset
  const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`
  const response = await fetch(url)
  const data = await response.text()

  section.closest('.shopify-section').outerHTML = data

  document.querySelectorAll('.recommended-products [data-bs-toggle="popover"]')
    .forEach((el) => bootstrap.Popover.getOrCreateInstance(el))

  initFeaturedProducts()

  const customEvent = new CustomEvent('init.ecomify.recommended_products')
  window.dispatchEvent(customEvent)
}
initRecommendedProducts()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.recommended-products')) {
    initRecommendedProducts()
  }
})